// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';
import * as api from '../../api/setupServices';
import * as portalApi from '../../api/portalServices';

import { DocumentPurpose } from '../../api/types';
import type { AppError } from '../../errorHandler/errors';

export type LegalFilesSaveType = {
  consentFile?: File;
  noticeFile?: File;
};

function useLegalFilesSave() {
  return useMutation<void, AppError, LegalFilesSaveType>({
    mutationFn: async ({ consentFile, noticeFile }) => {
      if (consentFile) {
        await prepareAndUploadFile(consentFile, DocumentPurpose.CONSENT);
      }
      if (noticeFile) {
        await prepareAndUploadFile(noticeFile, DocumentPurpose.NOTICE);
      }
    },
    onError: (error) => {
      throw error;
    },
  });
}

async function prepareAndUploadFile(file: File, purpose: DocumentPurpose) {
  const uploadLinks = await portalApi.getPrepareUploadUrl(file.name, purpose);
  await api.uploadFile(file, uploadLinks?.uploadUrl || '');
  await portalApi.completeLegalDocumentsUpload(uploadLinks.readUrl, uploadLinks.operationId);
}

export default useLegalFilesSave;
